export default function Shield({
  color,
  dimension = 24,
}: {
  color: string;
  dimension?: number;
}) {
  return (
    <svg
      width={dimension}
      height={dimension}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M0.732984 2.99913C3.1396 2.96648 5.33232 2.04827 7.0001 0.555573C8.66787 2.04827 10.8606 2.96648 13.2672 2.99913C13.3546 3.51975 13.4001 4.05458 13.4001 4.60003C13.4001 8.77991 10.7287 12.3359 7.0001 13.6537C3.27148 12.3359 0.600098 8.77991 0.600098 4.60003C0.600098 4.05458 0.645589 3.51975 0.732984 2.99913ZM9.96578 5.96569C10.2782 5.65327 10.2782 5.14674 9.96578 4.83432C9.65336 4.5219 9.14683 4.5219 8.83441 4.83432L6.2001 7.46864L5.16578 6.43432C4.85336 6.1219 4.34683 6.1219 4.03441 6.43432C3.72199 6.74674 3.72199 7.25327 4.03441 7.56569L5.63441 9.16569C5.94683 9.47811 6.45336 9.47811 6.76578 9.16569L9.96578 5.96569Z"
        fill={color}
      />
    </svg>
  );
}
